import { ChevronDownIcon } from "@heroicons/react/solid";
import React from "react";

import { Button } from "@/components/ui/button";
import { BasicTooltip } from "@/components/ui/Tooltip";

interface ScrollToBottomButtonProps {
  visible: boolean;
  onClick: () => void;
  className?: string;
  ariaLabel?: string;
  hasFooter?: boolean;
}

const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({
  visible,
  onClick,
  className = "",
  ariaLabel = "Scroll to bottom",
  hasFooter = false,
}) => (
  <BasicTooltip content={ariaLabel} side="left">
    <Button
      variant="outline"
      size="icon"
      className={`absolute ${
        hasFooter ? "bottom-20" : "bottom-6"
      } right-6 z-20 h-10 w-10 rounded-full border-gray-200 bg-white shadow-lg transition-all duration-300 hover:bg-gray-50 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-2 opacity-0"
      } ${className}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <ChevronDownIcon className="h-5 w-5" />
    </Button>
  </BasicTooltip>
);

export default ScrollToBottomButton;
